import React, { useState } from 'react';
import Card from '../Card';
import CheckBox from '../CheckBox';
import Divider from '../Divider';
import FlexBox from '../FlexBox';
import Rating from '../rating/Rating';
import MultiRangeSlider from '@component/multirange-slider/MultiRangeSlider';

import { H6, SemiSpan } from '../Typography';
import Button from '@component/buttons/Button';

type ValueType = {
  min: number;
  max: number;
};

interface ProductFilterCardProps {
  onMaxPriceChange?: (value: number) => void;
  onMinPriceChange?: (value: number) => void;
  onConditionChange?: (value: string) => void;
  onDeliveryChange?: (value: string) => void;
  onRatingChange?: (value: number) => void;
  onChange?: (value: ValueType) => void;
  clearFilters?: () => void;
  price?: any;
  maxPrice?: string;
  minPrice?: string;
  condition?: number;
  deliveryType?: string;
  rating?: number;
}

const ProductFilterCard = ({
  onConditionChange,
  onDeliveryChange,
  onRatingChange,
  clearFilters,
  onChange,
  maxPrice,
  minPrice,
  condition,
  deliveryType,
  rating,
}: ProductFilterCardProps) => {
  return (
    <Card p="18px 27px" elevation={5}>
      <H6 mb="16px">Price Range</H6>
      <SemiSpan>
        RM{minPrice || 0} - RM{maxPrice || 10000}
      </SemiSpan>
      <MultiRangeSlider min={0} max={10000} onChange={onChange} />

      <Divider my="24px" />

      <H6 mb="16px">Condition</H6>
      <CheckBox
        name="New"
        mb="1.5rem"
        color="secondary"
        checked={condition === 1}
        label="New"
        onChange={(e) => onConditionChange(e.target.name)}
      />
      <CheckBox
        name="Used"
        mb="1.5rem"
        color="secondary"
        checked={condition === 2}
        label="Used"
        onChange={(e) => onConditionChange(e.target.name)}
      />

      <Divider my="24px" />

      <H6 mb="16px">Delivery Options</H6>
      <CheckBox
        name="Cash on Delivery"
        value={'COD'}
        checked={deliveryType === 'COD'}
        color="secondary"
        label={<SemiSpan color="inherit">COD</SemiSpan>}
        my="10px"
        onChange={(e) => {
          onDeliveryChange(e.target.value);
        }}
      />
      <CheckBox
        name="Teakita Delivery"
        value={'TEAK_DELIVERY'}
        checked={deliveryType === 'TEAK_DELIVERY'}
        color="secondary"
        label={<SemiSpan color="inherit">Teakita Delivery</SemiSpan>}
        my="10px"
        onChange={(e) => {
          onDeliveryChange(e.target.value);
        }}
      />

      <CheckBox
        name="Teakita Fullfillment"
        value={'TEAK_FULFILMENT'}
        checked={deliveryType === 'TEAK_FULFILMENT'}
        color="secondary"
        label={<SemiSpan color="inherit">Teakita Fullfillment</SemiSpan>}
        my="10px"
        onChange={(e) => {
          onDeliveryChange(e.target.value);
        }}
      />

      <Divider my="24px" />

      <H6 mb="16px">Ratings</H6>
      {[5, 4, 3, 2, 1].map((item) => (
        <CheckBox
          key={item}
          value={item}
          color="secondary"
          checked={rating === item}
          label={<Rating value={item} outof={5} color="warn" />}
          my="10px"
          onChange={(e) => {
            onRatingChange(+e.target.value);
          }}
        />
      ))}
      <FlexBox alignItems="center" justifyContent="center" px="1.5rem" pt="2rem">
        <Button variant="text" color="secondary" px="1rem" onClick={clearFilters}>
          Clear Filters
        </Button>
      </FlexBox>
    </Card>
  );
};

const serviceOptions = ['Cash on Delivery', 'Teakita Delivery', 'Teakita Fulfillment'];
const conditionOptions = ['New', 'Used'];

export default ProductFilterCard;
